// extracted by mini-css-extract-plugin
export default {"box":"Cart_box__inBs8","empty":"Cart_empty__f3MKN","title":"Cart_title__V8tAI","itemBox":"Cart_itemBox__tsED8"};